import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../api/api";
import { setLoading } from "../../store/features/parkSlice";
import Loader from "../loader/Loader";
import Package from "../ticket/Package";

export default function Packages() {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.parkSlice);
  const { selectedBranch } = useSelector((state) => state.branchSlice);
  const [packages, setPackages] = useState([]);
  const fetch = useCallback(async () => {
    dispatch(setLoading(true));
    if (selectedBranch) {
      const res = await api.packages({ branch: selectedBranch });
      if (res.status === 200) {
        setPackages(res.data.data);
      }
    }

    dispatch(setLoading(false));
  }, [selectedBranch, dispatch]);
  useEffect(() => {
    fetch();
  }, [fetch]);

  return (
    <div className="d-flex gap-2 justify-content-center justify-content-md-start flex-wrap">
      {loading && (
        <div className="d-flex justify-content-center align-items-center pt-5 w-100">
          <Loader />
        </div>
      )}

      {!loading &&
        packages?.length > 0 &&
        packages?.map((item) => (
          <div
            key={item.id}
            style={{
              height: "322px",
              width: "230px",
            }}
          >
            <Package item={item} />
          </div>
        ))}
    </div>
  );
}
